import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPageModule } from "../pages/login/login.module";
import { DashboardPageModule } from '../pages/dashboard/dashboard.module';
import { RegisterPageModule } from '../pages/register/register.module';
import { ProfilePageModule } from '../pages/profile/profile.module';
import { AdminDashboardPageModule } from '../pages/adminDashboard/adminDashboard.module';
import { adminRequestPageModule } from "../pages/adminRequest/adminRequest.module";
import { RestProvider } from '../providers/rest/rest';
import { DataProvider } from '../providers/data/data';
import { MaterialPageModule } from '../pages/material/material.module';
import { ProjectPageModule } from '../pages/project/project.module';
import { TaskPageModule } from '../pages/task/task.module';
import { TaskListPageModule } from '../pages/taskList/taskList.module';
import { CustomersPageModule } from '../pages/customers/customers.module';
import { UserRequestPageModule } from '../pages/userRequest/userRequest.module';
import { CalendarPageModule } from '../pages/calendar/calendar.module';
import { SystemCalendarPageModule } from '../pages/systemCalendar/systemCalendar.module';
import { JobsPageModule } from '../pages/jobs/jobs.module';
import { CompanyInfoPageModule } from '../pages/companyInfo/companyInfo.module';
import { InfoSearchPageModule } from '../pages/InfoSearch/InfoSearch.module';
import { ProjectMorePageModule } from '../pages/projectMore/projectMore.module';
import { ConnectCompanyPageModule } from '../pages/connectCompany/connectCompany.module'
import {NgxPaginationModule} from 'ngx-pagination';
// import { Facebook, FacebookOriginal } from '@ionic-native/facebook';

import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { CalendarModule } from 'ion2-calendar';
import { File } from '@ionic-native/file/ngx';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    LoginPageModule,
    DashboardPageModule,
    AdminDashboardPageModule,
    adminRequestPageModule,
    RegisterPageModule,
    ProfilePageModule,
    ProjectPageModule,
    TaskPageModule,
    TaskListPageModule,
    MaterialPageModule,
    HttpClientModule,
    NgxPaginationModule,
    CustomersPageModule,
    UserRequestPageModule,
    CalendarModule,
    CalendarPageModule,
    SystemCalendarPageModule,
    JobsPageModule,
    CompanyInfoPageModule,
    InfoSearchPageModule,
    ProjectMorePageModule,
    ConnectCompanyPageModule,
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    RestProvider,
    DataProvider,
    LocalNotifications,
    File,
    // FacebookOriginal,
    {provide: ErrorHandler, useClass: IonicErrorHandler,},

  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts